import { Component } from '@angular/core';
import { Router, NavigationEnd } from '@angular/router';

interface NavigationItem {
  route: string;
  label: string;
}

interface NavigationConfig {
  fe: NavigationItem[];
  water: NavigationItem[];
  oilGas: NavigationItem[];
}

@Component({
  selector: 'main-page',
  templateUrl: './main-page.component.html',
  styleUrls: ['./main-page.component.scss'],
  standalone: false,
})
export class MainPageComponent {
  dropdownStates = {
    fe: false,
    water: false,
    oilGas: false
  };

  navigationConfig: NavigationConfig = {
    fe: [
      { route: '/fe/capacities', label: 'FE Capacities' },
      // { route: '/fe/scenario-modelling', label: 'Scenario Modelling' },
      { route: '/fe/flow-network', label: 'FE Flow Network' },
      { route: '/fe/corridor-systems', label: 'FE Corridor Systems' },
      { route: '/fe/admin', label: 'Admin' }
    ],
    water: [
      // { route: '/water-disposal/active-standards', label: 'Active Standards' },
      // { route: '/water-disposal/water-standards', label: 'Water Standards' },
      { route: '/water-disposal/water-capacities-view', label: 'Water Capacites' },
      { route: '/water-disposal/water-flow-network', label: 'Water Flow Network' },
      { route: '/water-disposal/water-sub-dev-area', label: 'Water Sub Dev Area' },
      { route: '/water-disposal/alternate-water-capacity', label: 'Alternate Water Capacity' },
      { route: '/water-disposal/water-admin-view', label: 'Admin' },

    ],
    //  water: [
    //   { route: '/water-disposal/active-standards', label: 'Active Standards' },
    //   { route: '/water-disposal/water-standards', label: 'Water Standards' },
    // ],
    oilGas: [
      // { route: '/oil-gas-tab/oil-gas', label: 'Oil & Gas' },
      { route: '/oil-gas-tab/gas-plant-capacities', label: 'Gas Plant Capacities' },
      { route: '/oil-gas-tab/cdp-flow-network', label: 'CDP Flow Network' },
      { route: '/oil-gas-tab/cdp-corridor-mapping', label: 'CDP Corridor Systems' },
      { route: '/oil-gas-tab/alternate-capacity', label: 'Alternate Capacity' },
      { route: '/oil-gas-tab/gas-plant-mapping', label: 'Admin' }
    ]
  };

  constructor(private router: Router) { }

  toggleDropdown(type: keyof typeof this.dropdownStates) {
    this.dropdownStates[type] = true;
  }

  closeDropdown(type: keyof typeof this.dropdownStates) {
    this.dropdownStates[type] = false;
  }

  isActiveRoute(route: string): boolean {
    return this.router.url.startsWith(route);
  }

  isHomeRoute(): boolean {
    return this.router.url === '/home';
  }

  isStandaloneRoute(): boolean {
    return ['/home', '/aggregator', '/outlook'].includes(this.router.url);
  }
}
